<div fxLayout="column" fxLayoutAlign="center center" fxFlexFill class="sam-margin">
   <fa-icon class="sam-margin" [icon]="icon" size="2x"></fa-icon>
   {{ textTranslationKey | translate }}
</div>
